module.exports = __webpack_public_path__ + "static/media/login_tips1.5da7b836.png";